import reduceReducers from 'reduce-reducers'
//import { Actions, Selectors } from '@store/typings'
import createFetchModule from '@utils/store/createFetchModule'
import { FetchActionsWith } from '@typings/generic'

// TODO - this should not be named "xGrid"

export const moduleName = 'stockAdviceItemsGrid'

const fetchModule = createFetchModule('@store/StockAdviceItemsGrid', 'LOAD', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
}
